// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"CommonTable_tableContainer__3Yhti","loaderWrapper":"CommonTable_loaderWrapper__1n-h_","noResultContainer":"CommonTable_noResultContainer__1G4ql"};